/**
 * @generated SignedSource<<c77f22729318be79f70abddd6db950c4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceViewFragment$data = {
  readonly id: string;
  readonly publishedAt?: DateTime | null | undefined;
  readonly viewerCanEdit?: boolean;
  readonly " $fragmentType": "WorkspaceViewFragment";
};
export type WorkspaceViewFragment$key = {
  readonly " $data"?: WorkspaceViewFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceViewFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceViewFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publishedAt",
          "storageKey": null
        },
        {
          "alias": "viewerCanEdit",
          "args": [
            {
              "kind": "Literal",
              "name": "action",
              "value": "UPDATE_WORKSPACE"
            }
          ],
          "kind": "ScalarField",
          "name": "viewerCan",
          "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE\")"
        }
      ],
      "type": "WorkspaceVersion",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "0e1b80bdb5c346812f21b944bb0c4c71";

export default node;
